import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck, Lock, Download, FileText, CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 bg-[#0C2818] text-white overflow-hidden" data-id="element-182">
      {/* Subtle dot pattern */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-183"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-184">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-185">
          <span className="inline-block py-1 px-4 rounded-full bg-[#FBBF24]/20 text-[#FBBF24] font-black text-sm mb-6 uppercase tracking-widest border border-[#FBBF24]/30" data-id="element-186">
            MEGAPACK LISTO PARA IMPRIMIR
          </span>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black mb-8 leading-tight text-white" data-id="element-187">
            Todo tu año de Educación Física resuelto.
          </h1>
        </motion.div>

        {/* Product Pack Composition - All books forming a complete pack */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative max-w-lg mx-auto mb-10" data-id="element-188">
          <div className="absolute -inset-4 bg-gradient-to-r from-[#FBBF24] to-[#F97316] rounded-xl blur-2xl opacity-30" data-id="element-189"></div>

          <div className="relative w-[320px] h-[240px] md:w-[460px] md:h-[320px] mx-auto" data-id="element-190">
            {/* Bonus books fanned behind */}
            <img src="https://cdn.magicpatterns.com/uploads/eAavdGDwKT6TkE74KtW7RF/bono_4.png" alt="Bono 4" className="absolute w-20 md:w-28 rounded-md shadow-lg pointer-events-none" style={{
            left: '2%',
            top: '20%',
            transform: 'rotate(-12deg)',
            zIndex: 1
          }} data-id="element-191" />
            <img src="https://cdn.magicpatterns.com/uploads/daZk6Cr1WwNzg8bCz3Cf8H/bono_1.png" alt="Bono 1" className="absolute w-20 md:w-28 rounded-md shadow-lg pointer-events-none" style={{
            left: '10%',
            top: '8%',
            transform: 'rotate(-6deg)',
            zIndex: 2
          }} data-id="element-192" />
            <img src="https://cdn.magicpatterns.com/uploads/3NpYhKtd9rcmE2siPQ4GDy/bono_3.png" alt="Bono 3" className="absolute w-20 md:w-28 rounded-md shadow-lg pointer-events-none" style={{
            right: '2%',
            top: '20%',
            transform: 'rotate(12deg)',
            zIndex: 1
          }} data-id="element-193" />
            <img src="https://cdn.magicpatterns.com/uploads/nTd3oYn3NTFUuqvnhUmNru/bono_2.png" alt="Bono 2" className="absolute w-20 md:w-28 rounded-md shadow-lg pointer-events-none" style={{
            right: '10%',
            top: '8%',
            transform: 'rotate(6deg)',
            zIndex: 2
          }} data-id="element-194" />
            {/* Main book - front and center */}
            <img src="https://cdn.magicpatterns.com/uploads/1YUtJDJVs1ZKhrEJoXRy3i/1_COVER.png" alt="MegaPack Educación Física LISTA" className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-32 md:w-44 rounded-lg shadow-2xl border-2 border-white/20 pointer-events-none" style={{
            zIndex: 3
          }} data-id="element-195" />
            {/* Glow behind the pack */}
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 md:w-64 md:h-64 rounded-full opacity-25" style={{
            background: 'radial-gradient(circle, #FBBF24 0%, transparent 70%)',
            zIndex: 0
          }} data-id="element-196" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-197">
          <h2 className="text-2xl md:text-3xl font-bold text-[#FBBF24] mb-6" data-id="element-198">
            Listo para usar. Sin buscar más.
          </h2>

          <p className="text-lg md:text-xl text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-199">
            El sistema que ya utilizan miles de docentes de educación física
            para organizar todo el año escolar en una sola tarde, sin improvisar
            clases y sin pasar horas preparando actividades cada semana.
          </p>

          <div className="bg-white/5 border border-white/10 rounded-2xl p-6 mb-8 max-w-2xl mx-auto backdrop-blur-sm" data-id="element-200">
            <p className="text-lg font-medium text-white flex items-start gap-3 text-left" data-id="element-201">
              <CheckCircle2 className="w-6 h-6 text-[#16A34A] flex-shrink-0 mt-0.5" data-id="element-202" />
              <span data-id="element-203">
                Más de 200 actividades y clases listas para aplicar en el patio
                o gimnasio, organizadas por nivel y edad.
              </span>
            </p>
          </div>

          {/* Badges */}
          <div className="flex flex-wrap justify-center gap-3 mb-10" data-id="element-204">
            {['100% PDF', 'Acceso inmediato', 'Para primaria y secundaria'].map((badge, i) => <span key={i} className="bg-[#143524] text-gray-300 px-4 py-2 rounded-full text-sm font-medium border border-[#1E4D2B]" data-id="element-205">
                  {badge}
                </span>)}
          </div>

          {/* CTA */}
          <button id="hero-cta" onClick={scrollToPurchase} className="inline-flex items-center justify-center gap-3 bg-[#16A34A] hover:bg-[#15803D] text-white font-black text-xl md:text-2xl py-5 px-10 rounded-full shadow-[0_0_30px_rgba(22,163,74,0.4)] hover:shadow-[0_0_40px_rgba(22,163,74,0.6)] transform hover:scale-105 transition-all duration-300 w-full md:w-auto" data-id="element-206">
            QUIERO MI MEGAPACK AHORA
            <ArrowRight className="w-6 h-6" data-id="element-207" />
          </button>

          {/* Trust Strip */}
          <div className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3 text-xs md:text-sm text-gray-400 max-w-3xl mx-auto" data-id="element-208">
            <div className="flex items-center gap-1.5" data-id="element-209">
              <ShieldCheck className="w-4 h-4 text-[#16A34A]" data-id="element-210" />
              <span data-id="element-211">Garantía 30 días</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-212">
              <Lock className="w-4 h-4 text-[#16A34A]" data-id="element-213" />
              <span data-id="element-214">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-215">
              <Download className="w-4 h-4 text-[#16A34A]" data-id="element-216" />
              <span data-id="element-217">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-218">
              <FileText className="w-4 h-4 text-[#16A34A]" data-id="element-219" />
              <span data-id="element-220">Descarga inmediata después de comprar</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-221">
              <ShieldCheck className="w-4 h-4 text-[#16A34A]" data-id="element-222" />
              <span data-id="element-223">Protección total de datos</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}